import { Spinner, SpinnerSize, Text } from '@bechtel/gds';
import { useSearchToolRoom } from '@bechtel/ht-clients-common';
import { SortType } from '@bechtel/ht-types';
import { get } from 'lodash';
import { FC, useEffect, useState } from 'react';
import { ToolRoomItem } from '~/components/tool-rooms';
import {
  LoaderContainer,
  SubtitleStyled,
  ToolRoomBoxStyled,
  ToolRoomContainer,
  ToolRoomListAreaStyled,
} from './styled';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ToolRoomsProps {}
export const ToolRooms: FC<ToolRoomsProps> = () => {
  const [editItemIndex, setEditItemIndex] = useState<number>(-1);
  const { searchToolRoom, data: toolRoomListData, loading: toolRoomLoading } = useSearchToolRoom();
  const toolRooms = get(toolRoomListData, 'searchToolRooms.items', []);
  const onSelectEdit = (index: number, type: string) => {
    if (type == 'save') {
      setEditItemIndex(-1);
    } else {
      setEditItemIndex(editItemIndex == index ? -1 : index);
    }
  };
  useEffect(() => {
    searchToolRoom({
      sortInput: [{ field: 'name', sort: SortType.ASC }],
    });
  }, []);
  return (
    <ToolRoomBoxStyled>
      <ToolRoomContainer>
        <Text family="openSansSemiBold" weight="600" size="500" color="neutral.800">
          Manage Tool Rooms
        </Text>
        <SubtitleStyled>Add,Manage Tool Rooms for a project</SubtitleStyled>
        {toolRoomLoading && (
          <LoaderContainer>
            <Spinner size={SpinnerSize.LARGE} />
          </LoaderContainer>
        )}
        <ToolRoomListAreaStyled>
          {toolRooms.map((item, index) => {
            return (
              <ToolRoomItem
                key={item.id}
                item={item}
                editing={editItemIndex == index}
                onEditClick={(x) => onSelectEdit(index, x)}
              />
            );
          })}
        </ToolRoomListAreaStyled>
      </ToolRoomContainer>
    </ToolRoomBoxStyled>
  );
};
